import React from "react";

export type ContentChunk =
  | { type: "text"; value: string }
  | { type: "tag"; value: string; variant: "respiration" | "effet-sonore" | "voix" };

type InlineTagProps = {
  label: string;
  variant: "respiration" | "effet-sonore" | "voix";
};

type ParagraphBlockProps = {
  index: number;
  title: string;
  content: ContentChunk[];
};

export function InlineTag({ label, variant }: InlineTagProps) {
  const className =
    variant === "respiration"
      ? "inline-flex items-center rounded-[4px] border border-[#623DC7] bg-[#E1D6FF] px-2 py-1 text-[12px] font-medium text-[#2F1E64]"
      : variant === "effet-sonore"
      ? "inline-flex items-center rounded-[4px] border border-[#C8009C] bg-[#FDEBF9] px-2 py-1 text-[12px] font-medium text-[#7D005F]"
      : "inline-flex items-center rounded-[4px] border border-[#623DC7] bg-[#E1D6FF] px-2 py-1 text-[12px] font-medium text-[#2F1E64]";
  return <span className={className}>{label}</span>;
}

export function NumberBadge({ number }: { number: number }) {
  return (
    <div className="relative flex h-6 w-6 shrink-0 items-center justify-center select-none">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
      >
        <path
          d="M 12 2 L 22 10 L 22 22 L 2 22 L 2 10 Z"
          fill="#EFF6FF"
          stroke="#007AFF"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
      <span className="relative z-10 text-[11px] font-bold text-[#007AFF] mt-[1px]">
        {number}
      </span>
    </div>
  );
}

export function ParagraphBlock({ index, title, content }: ParagraphBlockProps) {
  return (
    <div className="flex w-full flex-col gap-2">
      <div className="inline-flex items-center gap-2">
        <NumberBadge number={index} />
        <span className="text-[14px] font-semibold text-[#0F172B]">{title}</span>
      </div>
      <p className="text-[14px] font-normal leading-6 text-[#334155]">
        {content.map((chunk, i) =>
          chunk.type === "text" ? (
            <span key={i}>{chunk.value}</span>
          ) : (
            <InlineTag key={i} label={chunk.value} variant={chunk.variant} />
          )
        )}
      </p>
    </div>
  );
}
